import { Component, OnInit } from '@angular/core';

import { GameControlsBase } from '../../game-controls.base';
import { AuthService } from '../../../../../auth/auth.service';
import { CurrencyMultiplierPipe } from '../../../../../shared/utils/currency-multiplier.pipe';
import { ManagerService } from '../../../../../core/services/manager.service';

@Component({
  selector: 'app-game-controls-desktop',
  templateUrl: './game-controls-desktop.component.html',
  styleUrls: ['./game-controls-desktop.component.scss']
})
export class GameControlsDesktopComponent extends GameControlsBase implements OnInit {

  constructor(public authService: AuthService, public managerService: ManagerService) {
    super();
  }

  ngOnInit() {
  }


}
